

let id = 0;

export function generateId() {
	id++;
	return id;
}
